<template>
  <div class="verify-coAuthorship dialog">
    <ipub-model :visable="isVisable"
                maskClose
                width="502px"
                @cancel="cancel"
                :showFooter="false"
                title="Verify Co-Authorship">
      <template>
        <div class="mar-b-8 verify-card ">I’m a co-author of the submission.</div>
        <ipub-button type="primary"
                     class="mar-b-20"
                     @click="confirm">Confirm my Co-Authorship</ipub-button>
        <div class="mar-b-8 verify-card">I’m not a co-author of the submission.</div>
        <ipub-button type="primary"
                     class="mar-b-10"
                     @click="decline">Decline Contributor Verification</ipub-button>
        <div class="verify-card ">If you did not co-author the submission, you can contact the corresponding author to resolve the issue with them before the submission proceeds further.</div>
      </template>
    </ipub-model>
  </div>

</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    isVisable: {
      type: Boolean,
      default: true,
    },
    inputData: {
      type: Object,
      default () {
        return {}
      },
    },
  },
  computed: {
    ...mapGetters({
      user: 'getUser'
    })
  },
  data () {
    return {
      code: ""
    }

  },
  mounted () {
  },
  methods: {
    confirm () {
      this.code = this.inputData.coAuthor.code
      this.$emit('confirm', this.code)
    },
    decline () {
      this.code = this.inputData.coAuthor.code
      this.$emit('decline', this.code)
    },
    cancel () {
      this.$emit('cancel')
    },
  }
}
</script>

<style>
.verify-card {
  font-size: 16px;
  font-weight: 400;
}
</style>